import Vue from 'vue';
import Vuex from 'vuex';
import Puzzle from '@/store/module/puzzle';
import UI from '@/store/module/ui';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    Puzzle,
    UI,
  },
  state: {
  },
  mutations: {
  },
  actions: {
  },
});
store.dispatch('Puzzle/init');

export default store;
